export default postalOperators => postalOperators
  .filter(postalOperator =>
    postalOperator.ediMailboxList && postalOperator.ediMailboxList.length)
  .map((postalOperator) => {
    const childrenMailbox = postalOperator.ediMailboxList
      .map(mailbox =>
        ({
          value: mailbox,
          label: mailbox,
        }));
    return {
      value: postalOperator.postalOperatorCode,
      label:
          (postalOperator.shortPostalOperatorCode ? `${postalOperator.shortPostalOperatorCode} - ` : '') + (postalOperator.shortName
        ? postalOperator.shortName : ''),
      children: childrenMailbox,
    };
  });
